<render-custom-metadata [fields]="driver.metadata.configuration" [driverId]="driver.id" type="configuration" (event-status)="handleEventEmitted($event)"></render-custom-metadata>
